import { getProjectStatusLabel, ProjectStatusEnum } from "@nlc/shared-types";

import { Badge, type BadgeVariant } from "@/components/badge";

const PROJECT_STATUS_VARIANT: Record<ProjectStatusEnum, BadgeVariant> = {
  [ProjectStatusEnum.ACTIVE]: "success-vibrant",
  [ProjectStatusEnum.ARCHIVED_OR_DELETED]: "primary",
  [ProjectStatusEnum.CANCELLED]: "red-vibrant",
  [ProjectStatusEnum.DRAFT]: "primary",
  [ProjectStatusEnum.INACTIVE]: "error",
  [ProjectStatusEnum.IS_INTERNAL]: "purple",
  [ProjectStatusEnum.KICKSTARTER]: "indigo-vibrant",
  [ProjectStatusEnum.MAINTENANCE]: "blue-light",
  [ProjectStatusEnum.PAUSED]: "orange",
  [ProjectStatusEnum.PENDING_CANCELLATION]: "warning",
};

interface ProjectStatusBadgeProps {
  status: ProjectStatusEnum | undefined;
}

export function ProjectStatusBadge({ status }: ProjectStatusBadgeProps) {
  if (!status) return null;

  return (
    <Badge
      className="inline-flex justify-center whitespace-nowrap"
      isRounded
      size="small"
      variant={PROJECT_STATUS_VARIANT[status] ?? "primary"}
    >
      {getProjectStatusLabel(status)}
    </Badge>
  );
}
